import { v4 as uuidv4 } from "uuid";
export class MenuModel {
    constructor() {
        this.id = uuidv4();
        this.text = '';
        this.data = null;
        this.children = null;
    }
}
export class Menu extends MenuModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
